<template>
    <v-card>
        <h1 class="text-pagename text-xs-center">General setting</h1>
        <general/>
    </v-card>
</template>

<script>

import general from '@/components/back-office/Rider/Setting/General';
    export default {
        data() {
            return {
            }
        },
        components: {
            general
        },
        mounted() {
            const path = [{
                    text: 'Select province',
                    disabled: false,
                    href:  "/weserve_admin_login/select/"
                },
                {
                    text: 'Select service',
                    disabled: false,
                    href: '/weserve_admin_login/control/' + this.$route.params.province
                }, 
                {
                    text: 'Rider',
                    disabled: false,
                    href: '/weserve_admin_login/control/' + this.$route.params.province + '/rider/riderinhouse'
                    // href: '/weserve_admin_login/control/' + this.$route.params.province + '/rider/riderdashboard'
                }, 
                {
                    text: 'General',
                    disabled: true,
                }
            ]
            this.$store.commit("backOffice/saveRecentRoute", path);
  }
    }
</script>
